import { useEffect, useMemo, useRef, useState } from 'react';
import { AfbCardService } from '../../../../services/AfbCardService';
import { SpaceService } from '../../../../services/SpaceService';
import { ChangeAlertCallbackType } from '../../../Root';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import StyleOutlinedIcon from '@mui/icons-material/StyleOutlined';
import TrackChangesOutlinedIcon from '@mui/icons-material/TrackChangesOutlined';
import ReceiptLongOutlinedIcon from '@mui/icons-material/ReceiptLongOutlined';
import { statusAfbCards } from '../../../../util/DataObject';
import { JsonToCsv } from '../../../../util/JsonToCsv';
import { CustomMenu } from '../../../elements';
import { startDate } from '../../../elements/DateRangePicker';
import moment from 'moment';
moment.locale('es');

export const useAfbCardsTable = (changeAlert: ChangeAlertCallbackType, onOpenDialog, onOpenInfoDialog) => {

    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [search, setSearch] = useState({});
    const [searchData, setSearchData] = useState({});
    const [disabledSearch, setDisabledSearch] = useState(true);
    const afbCardService = useRef<AfbCardService>();
    const spaceService = useRef<SpaceService>();

    const [rowsPerPage, setRowsPerPage] = useState(20);
	const [totalRows] = useState(0);
	// const [totalRows, setTotalRows] = useState(0);
	const [page, setPage] = useState(1);

    const [dialogData, setDialogData] = useState({
        info: {}, text: {}, type: ""
    });

	let info = localStorage.session ? JSON.parse(localStorage.session) : {};

    const saveData = async (result) => {
        setLoading(true);       
        setData(result.content.request_list || []);
        setLoading(false);
    };
    const onSetSearch = (payload) => {
        setSearchData(payload)
    }
    const onSetTypeSearch = (e) => {
        setSearch({[e.target.value]: ""})
    }

    const onHandleChange = (e) => {
        let value = e.target.value.trim()
        let key = Object.keys(search)[0]
        setSearch(JSON.parse(JSON.stringify({[key] : value})));
        setDisabledSearch(JSON.parse(JSON.stringify(!value)));
    }

    const onHandleSearch = async (request, update=true, getSearch=false) => {
        setLoading(true);
        if(update){
            setSearch({});
            onSetSearch(request);
        }
        if(getSearch){
            let key = Object.keys(search)[0]
            searchData["filters"] = {...searchData["filters"], [key]: search[key]}
        }

        const response = await afbCardService.current.afbCardSearch(getSearch ? searchData : request);
        if (response.data.response === 'OK') {
            if(update || (!update && getSearch)){
                saveData(response.data.widget[0].data || [])
            } else {
                setLoading(false);
                return response.data.widget[0].data
            }
        } else {
            changeAlert(true, 'error', response.data.message);
        }
        setLoading(false);
    }

    const onHandleUpdate = async (data, type) => {
        setLoading(true);
        const response = await afbCardService.current[type === "billed" ? "afbCardUpdateBilled" : "afbCardUpdateDeadline"]({data: data});
        if (response?.data?.response === 'OK') {
            changeAlert(true, 'success', 'La fecha de activación se ha actualizado con éxito');
            onHandleSearch(searchData)
        } else {
            changeAlert(true, 'error', response.message || response.data.message);
        }
        setLoading(false);
    };

    const changePage = (action, page, rows= rowsPerPage) => {
		setPage(page+1);
		// findTx(page+1, rows);
	};

	const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
		setRowsPerPage(JSON.parse(JSON.stringify(event.target.value)));
		changePage(null, 0, parseInt(event.target.value, 10));
	};

    const getCards = async (uuid) => {
        setLoading(true);
        const response = await spaceService.current.spaceCompanyCards(uuid);
        if (response?.data?.response === 'OK') {
            setLoading(false);
            return response.data.widget[0].content
        } else {
            setLoading(false);
            changeAlert(true, 'error', response.message || response.data.message);
        }
    }

    const downloadReport = async () => {
        let payload = {
            filters: {
                type: ["worker"],
                billed: false,
                billable: true,
            },
            pagination: {
                page_number: 1,
                results_per_page: 30
            }
        }

        const request = await onHandleSearch(payload, false);
        if(request.content.request_list){
            let newList = request.content.request_list.map((item) => {
                return {
                    company_name: item["company_name"],
                    tax_id: item["tax_id"],
                    retained_amount: item["retained_amount"]
                }
            })
            setLoading(true);
            let columns = [
                { header: "Razón social de la empresa", key: "company_name", width: 40,},
                { header: "RFC de la empresa", key: "tax_id", width: 30 },
                { header: "Monto retenido (por facturar)", key: "retained_amount", width: 20},
            ];
            let fileName = `facturacion-${startDate}`
            JsonToCsv(newList, columns, fileName)
            setLoading(false);
        }
    }
    
    const updateCardDialog = (row, agent, type) => {
        switch (type) {
            case "deadline":
                setDialogData({
                    type: type,
                    info: {row, agent},
                    text: {title: "Fecha límite de activación", message: "Elije una fecha límite para la activación de tarjetas de este lote"}
                })
                onOpenDialog()
                break;
            case "billed":
                if(!row.billed){
                    let uuid = row.uuid
                    setDialogData({
                        type: type,
                        info: {uuid, agent},
                        text: {title: "Facturación de lote", message: "Confirma si la factura del depósito en garantía vencido, ya fue enviada"}
                    })
                    onOpenDialog()
                } else {
                    changeAlert(true, 'success', 'El lote ya fue facturado');
                }
                break;
        }
    }

    const infoCardDialog = async (row, type) => {
        switch (type) {
            case "cards":
                var result = await getCards(row.customer_uuid)
                setDialogData({
                    type: type,
                    info: {result},
                    text: {title: `Tarjetas - ${result.customer.general.corporate_name}`, message: ""}
                })
                onOpenInfoDialog()
                break;
            case "tracking":
                setDialogData({
                    type: type,
                    info: {row},
                    text: {title: "Números de guía", message: "Enviados por DHL"}
                })
                onOpenInfoDialog()
                break;
        }
    }

    const onHandleReset = () => {
        let s = searchData;
        Object.keys(search).map(i => delete s["filters"][i]);

        setSearch({});
        setSearchData(JSON.parse(JSON.stringify(s)));

        return onHandleSearch(s)
    };

    useEffect(() => {
        afbCardService.current = new AfbCardService(changeAlert)
        spaceService.current = new SpaceService(changeAlert)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const actionExecute = (data, key) => {
        switch (key) {
            case "updateDeadline":
                return updateCardDialog(data, info.email, "deadline");
            case "updateBilled":
                return updateCardDialog(data, info.email, "billed");
            case "companyCards":
                return infoCardDialog(data, "cards");
            case "trackingOrder":
                return infoCardDialog(data, "tracking");
            default:
                break;
        }
        return 
    }

    const options = [
        {key: "updateDeadline", label: "Fecha de activación", icon: <CalendarMonthIcon/>},
        {key: "updateBilled", label: "Facturar lote", icon: <ReceiptLongOutlinedIcon/>},
        {key: "companyCards", label: "Total tarjetas solicitadas", icon: <StyleOutlinedIcon/>},
        {key: "trackingOrder", label: "Rastreo", icon: <TrackChangesOutlinedIcon/>},
    ]

    const calculateColumns = useMemo(() => {
        const columns = [
            { selector: (row) => row.uuid_suitcase, name: 'Suitcase', wrap: true, sortable: true, width: "17%" },
            { selector: (row) => row.request_key, name: 'Referencia', wrap: true, sortable: true, width: "10%" },
            { selector: (row) => row.tax_id, name: 'RFC', wrap: true, sortable: true, width: "10%" },
            { selector: (row) => row.company_name, name: 'Razón Social', wrap: true, sortable: true, width: "10%" },
            { selector: (row) => row.active_count + "/" + row.card_count, name: 'Tarjetas activas', wrap: true, sortable: true, width: "8%" },
            { selector: (row) => <div style={{display: 'flex'}}>{row.billed ? <ReceiptLongOutlinedIcon color='success' sx={{mr: 1}}/> : <ReceiptLongOutlinedIcon color='error' sx={{mr: 1}}/>} {row.retained_amount + " $"}</div>, name: 'Monto', wrap: true, sortable: true, width: "11%" },
            { selector: (row) => moment(new Date(row.customer_ack_date)).tz('America/Mexico_City').format('L'), name: 'Fecha de solicitud', wrap: true, sortable: true, width: "10%" },
            { selector: (row) => moment(new Date(row.reimbursement_deadline)).tz('America/Mexico_City').format('L'), name: 'Fecha límite de activación', wrap: true, sortable: true, width: "10%" },
            { selector: (row) => statusAfbCards.filter((item) => row.status === item.key)[0].label || "N/A", name: 'Estado', wrap: true, sortable: true, width: "10%" },
            { cell: (row) => <CustomMenu size="small" row={row} options={options} action={actionExecute} />,
             	allowOverflow: true, button: true, width: "2%"
            },
        ]
        return columns
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [search])

    return { columns: calculateColumns, data, loading, search, disabledSearch, rowsPerPage, totalRows, page, dialogData, searchData,
        saveData, updateCardDialog, onHandleUpdate, onHandleChange, onHandleSearch, onSetTypeSearch, onSetSearch, handleChangeRowsPerPage, changePage, downloadReport, onHandleReset }
};